import ReactDOM from 'react-dom/client'
import { App } from './App'
import './main.css'
import componentsCss from '@sonans/components/dist/index.css?raw'
import { Provider } from 'react-redux'
import { store } from './reducers'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from "@sentry/react";

const _sometypeFontEl = document.createElement('link')
_sometypeFontEl.rel = 'stylesheet'
_sometypeFontEl.href = 'https://fonts.googleapis.com/css2?family=Sometype+Mono:ital,wght@0,400..700;1,400..700&display=swap'
document.head.appendChild(_sometypeFontEl)

const _sonansCssEl = document.createElement('style')
_sonansCssEl.textContent = componentsCss
document.head.insertBefore(_sonansCssEl, document.head.firstChild)

const _overridesCssEl = document.createElement('style')
_overridesCssEl.textContent = `
:root {
    --sonans-green: #C6FCB4;
    --font-sometype-mono: 'Sometype Mono', monospace;
}
.font-mono {
    font-family: 'Sometype Mono', ui-monospace, monospace !important;
}
input, input::placeholder {
    font-family: 'Sometype Mono', ui-monospace, monospace !important;
}
.bg-primary {
    background-color: #FFE600 !important;
}
.border-primary {
    border-color: #FFE600 !important;
}
.hover\:bg-primary:hover {
    background-color: #FFE600 !important;
}
.karakterkalkulator_start_black {
    background-color: #000000 !important;
    border-color: #000000 !important;
    color: #ffffff !important;
}
.karakterkalkulator_start_black:hover {
    background-color: #ffffff !important;
    border-color: #ffffff !important;
    color: #000000 !important;
}
.bg-sonans-new-green {
    background-color: rgba(255, 230, 0, 0.35) !important;
}
.karakterkalkulator_plus_btn {
    background-color: var(--sonans-green) !important;
}
.bg-lime02 {
    background-color: #C6FCB4 !important;
}
.border-lime05 {
    border-color: #a3e8b3 !important;
}
.bg-sonans-new-primary {
    background-color: rgba(255, 230, 0, 0.35) !important;
}

[role="checkbox"] {
    border-color: #9ca3af !important;
    border-width: 2px !important;
    border-style: solid !important;
}
[role="checkbox"][aria-checked="true"] {
    border-color: #000000 !important;
    background-color: #000000 !important;
}
.border-2 {
    border-width: 2px !important;
    border-style: solid !important;
}
.border-black {
    border-color: #000000 !important;
}
.pearl {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
}
.karakterkalkulator_start {
    padding: 0 2rem !important;
    height: 4.5rem !important;
    width: min(calc(100vw - 3rem), 24rem) !important;
    margin-left: auto !important;
    margin-right: auto !important;
}
.karakterkalkulator_start:hover {
    background-color: #000000 !important;
    border-color: #000000 !important;
    color: #ffffff !important;
}
.hover\:bg-black:hover {
    background-color: #000000 !important;
}
.hover\:border-black:hover {
    border-color: #000000 !important;
}
.hover\:text-white:hover {
    color: #ffffff !important;
}
.karakterkalkulator_forsiden_referansekode_hentutregning:hover {
    background-color: #000000 !important;
    border-color: #000000 !important;
    color: #ffffff !important;
}
.karakterkalkulator_utdanningsprogram_klikk {
    padding: 1.5rem !important;
    font-size: 1rem !important;
    line-height: 1.75rem !important;
    width: 100% !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.3) !important;
}
.karakterkalkulator_utdanningsprogram_klikk:last-child {
    border-bottom: none !important;
}
.karakterkalkulator_utdanningsprogram_klikk:hover {
    background-color: rgb(248, 250, 252) !important;
}
.karakterkalkulator_utdanningsprogram_undervalg {
    padding-left: 3rem !important;
}
.karakterkalkulator_utdanningsprogram_gul:hover {
    background-color: rgba(255, 230, 0, 0.35) !important;
}
.karakterkalkulator_course_header {
    background-color: rgb(245, 245, 246) !important;
    top: 39px !important;
    position: sticky !important;
    z-index: 30 !important;
}
.karakterkalkulator_highlight_info {
    padding: 1.5rem !important;
    font-size: 1rem !important;
    line-height: 1.75rem !important;
}
.karakterkalkulator_ai_skanner_btn {
    background-color: #FFE600 !important;
    border-color: #FFE600 !important;
    color: #000000 !important;
    padding: 0.5rem 1.5rem !important;
    font-size: 1rem !important;
    font-weight: 600 !important;
}
.karakterkalkulator_ai_skanner_btn:hover {
    background-color: #000000 !important;
    border-color: #000000 !important;
    color: #ffffff !important;
}
`
document.head.appendChild(_overridesCssEl)

Sentry.init({
  dsn: "https://9ab0e948196d53e71f36fbbeaf790c15@o4508091849572352.ingest.de.sentry.io/4508092886941776",
  enabled: import.meta.env.VITE_ENV === 'production',
  integrations: [
    Sentry.browserTracingIntegration(), 
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ["localhost"],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});


const root = ReactDOM.createRoot(
    document.getElementById('Karakterkalkulator') as HTMLElement
)
root.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
)
